import axios from 'axios';
import React, { useEffect, useState } from 'react'
import BASEURL from '../../Config/global';
import Loader from "../../Components/Loader";

const MobileWebViewInfoBox = () => {

    const [html, setHtml] = useState('');
    const [loader, setLoader] = useState(true);

    useEffect(() => {
        informationTray();
    }, []);


    const informationTray = async () => {
        const params = new URLSearchParams(window.location.search);
        const typeFromQuery = params.get('type');
        const idFromQuery = params.get('id');
        let endPoint = '';
        if (typeFromQuery === "coupon" || typeFromQuery === "coupon_sub_user" || typeFromQuery === "coupon_lead") {
            endPoint = "coupon-user";
        }
        if (typeFromQuery === "primary" || typeFromQuery === "sub_user" || typeFromQuery === "lead") {
            endPoint = "subscription-user";
        }
        try {
            setLoader(true);
            const response = await axios.get(`${BASEURL}/api/user/${endPoint}/${idFromQuery}/`);
            if (!response.data.error) {
                setHtml(response.data.data[0]?.html_info_text)
            }
            setLoader(false);
        } catch (error) {
            console.error(error);
        }
    }


    // if (loader) return <div className="spinner-border spinner-border-sm text-light" role="status"></div>

    return (
        <div className='p-3' style={{ backgroundColor: '#002046' }} dangerouslySetInnerHTML={{ __html: html }}></div>
    );
}

export default MobileWebViewInfoBox